<template>
  <div
    :class="`as-parent-h2h as-parent-h2h__item-h-auto as-parent-h2h-${siteName}`"
  >
    <div class="as-tab-bar">
      <TabsBtn
        :tabs="tabs"
        :activeTab="activeTab"
        @change="changeTab"
        :isShowBorder="true"
      />
    </div>
    <div class="as-sort-by" v-if="gSportType === 'badminton'">
      <div @click="filterIsSingles = !filterIsSingles">
        <span class="as-title"> Sắp xếp: </span>
        <span class="as-with-by">
          {{ filterIsSingles ? "Đánh đơn" : "Đánh đội" }}
        </span>
        <IConSort />
      </div>
    </div>
    <div class="as-statics-scores" v-if="gSportType === 'badminton'">
      <div class="as-statics-scores__item">
        <span class="__title">Thắng</span>
        <div class="as-number-scores as-score-win">
          <span class="__win">
            {{
              activeTab === "home"
                ? _winHome
                : activeTab === "away"
                ? _winAway
                : activeTab === "vs"
                ? _winHome + _winAway
                : 0
            }}
          </span>
        </div>
      </div>
      <div class="as-statics-scores__item">
        <span class="__title">Thua</span>
        <div class="as-number-scores as-score-win">
          <span class="__lose">
            {{
              activeTab === "home"
                ? _losesHome
                : activeTab === "away"
                ? _losesAway
                : activeTab === "vs"
                ? _losesHome + _losesAway
                : 0
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="as-filter-vs" v-if="gSportType == 'tennis'">
      <div class="as-filter-vs__filter">
        <div
          class="as-button-filter"
          role="button"
          @click="filterGround = filterGround === groundId ? null : groundId"
        >
          <div
            :class="filterGround === groundId ? 'as-checked' : 'as-none'"
            role="button"
          >
            <IconChecked v-if="filterGround == groundId" />
          </div>
          <span>{{ groundType }}</span>
        </div>
        <div
          class="as-button-filter"
          @click="filterIsSingles = !filterIsSingles"
        >
          <div
            :class="filterIsSingles ? 'as-checked' : 'as-none'"
            role="button"
          >
            <IconChecked v-if="filterIsSingles" />
          </div>
          <span>Đánh đơn</span>
        </div>
      </div>
      <div class="as-filter-vs__scores">
        <div>
          <span class="__title">Thắng:</span>
          <span class="__win">
            {{
              activeTab === "home"
                ? _winHome
                : activeTab === "away"
                ? _winAway
                : activeTab === "vs"
                ? _winHome + _winAway
                : 0
            }}
          </span>
        </div>
        <div>
          <span class="__title">Thua:</span>
          <span class="__lose">
            {{
              activeTab === "home"
                ? _losesHome
                : activeTab === "away"
                ? _losesAway
                : activeTab === "vs"
                ? _losesHome + _losesAway
                : 0
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="as-filter-vs" v-if="gSportType == 'volleyball'">
      <div class="as-filter-vs__filter">
        <div
          class="as-button-filter"
          role="button"
          @click="filterIsHomeGround = !filterIsHomeGround"
        >
          <div
            :class="filterIsHomeGround ? 'as-checked' : 'as-none'"
            role="button"
          >
            <IconChecked v-if="filterIsHomeGround" />
          </div>
          <span>Sân nhà</span>
        </div>
        <div
          class="as-button-filter"
          @click="filterIsThisSession = !filterIsThisSession"
        >
          <div
            :class="filterIsThisSession ? 'as-checked' : 'as-none'"
            role="button"
          >
            <IconChecked v-if="filterIsThisSession" />
          </div>
          <span>Mùa giải này</span>
        </div>
      </div>
      <div class="as-filter-vs__scores">
        <div>
          <span class="__title">Thắng:</span>
          <span class="__win">
            {{
              activeTab === "home"
                ? _winHome
                : activeTab === "away"
                ? _winAway
                : activeTab === "vs"
                ? _winHome + _winAway
                : 0
            }}
          </span>
        </div>
        <div>
          <span class="__title">Thua:</span>
          <span class="__lose">
            {{
              activeTab === "home"
                ? _losesHome
                : activeTab === "away"
                ? _losesAway
                : activeTab === "vs"
                ? _losesHome + _losesAway
                : 0
            }}
          </span>
        </div>
      </div>
    </div>
    <div v-show="activeTab === 'vs'">
      <h2 class="as-h2-title-box">Các trận đối đầu</h2>
      <H2hTab
        :h2h="h2hVs"
        :teams="h2h.teams"
        :competitions="tournaments"
        :match="match"
        tab="all"
        :homeTeamId="match.home_team_id"
        :key="activeTab"
        v-if="h2hVs.length"
        :isShowMore="isShowMoreVs"
        mode="vs"
        @handleIsShowMore="(newVal: string = 'vs') => handleShowMore(newVal)"
      />
      <NoData v-else modifyClass="as-h-50" />
    </div>
    <div
      class="as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup"
    >
      <div v-show="activeTab !== 'away'">
        <h2 class="as-h2-title-box">
          Các trận gần nhất: {{ match.home_team.name }}
        </h2>
        <H2hTab
          :h2h="h2hHome"
          :teams="h2h.teams"
          :competitions="tournaments"
          :match="match"
          tab="home"
          :homeTeamId="match.home_team_id"
          :key="activeTab"
          v-if="h2hHome.length"
          :isShowMore="isShowMoreHome"
          mode="home"
          @handleIsShowMore="(newVal: string = 'home') => handleShowMore(newVal)"
        />
        <NoData v-else modifyClass="as-h-50" />
      </div>
      <div v-show="activeTab !== 'home'">
        <h2 class="as-h2-title-box">
          Các trận gần nhất: {{ match.away_team.name }}
        </h2>
        <H2hTab
          :h2h="h2hAway"
          :teams="h2h.teams"
          :competitions="tournaments"
          :match="match"
          tab="away"
          :homeTeamId="match.away_team_id"
          :key="activeTab"
          v-if="h2hAway.length"
          :isShowMore="isShowMoreAway"
          mode="away"
          @handleIsShowMore="(newVal: string = 'away') => handleShowMore(newVal)"
        />
        <NoData v-else modifyClass="as-h-50" />
      </div>
    </div>
  </div>
</template>

  <script setup lang="ts">
import { defineProps, ref, computed, getCurrentInstance } from "vue";
import H2hTab from "~src/components/h2h/tennis/H2hTab.vue";
import type { IMatchTennis, IH2h } from "~src/interfaces/tennis";
import IconChecked from "~src/components/icons/IconChecked.vue";
import { parseMatchH2hData } from "~src/helpers/tennis";
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";
import NoData from "~src/components/NoData.vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";
import IConSort from "~src/components/icons/IConSort.vue";
const commonStore = usecommonStore();

interface IProps {
  h2h: IH2h;
  match: IMatchTennis;
}

const props = withDefaults(defineProps<IProps>(), {});

const instance:any = getCurrentInstance();

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("vs");
const filterGround = ref(null);
const filterIsHomeGround = ref(false);
const filterIsThisSession = ref(false);
const _winHome = ref(0);
const _losesHome = ref(0);
const _winAway = ref(0);
const _losesAway = ref(0);

const filterIsSingles = ref(
  (props.match.away_team?.sub_ids?.length || 0) > 0 &&
    (props.match.home_team?.sub_ids?.length || 0) > 0
    ? false
    : true
);

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: "Toàn bộ",
    key: "vs",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
};

const _getWinsLoses = (data: any[] = [], mode: string = "win") => {
  let number = 0;

  if (data) {
    data.forEach((item: any) => {
      const __item = parseMatchH2hData(item, props.match.home_team?.id);
      if (
        (__item?.match_time_player as { text: string; status_h2h: string })
          ?.status_h2h === mode
      ) {
        number += 1;
      }
    });
  }

  return number;
};

const groundId = computed(() => {
  return props.match.tournament?.ground_id ?? 0;
});

const groundType = computed(() => {
  const groundTypeText = MatchEnum.GROUND_TYPE_STTAUS as Record<number, string>;
  const ground_id = groundId.value;
  return groundTypeText[ground_id] ?? "";
});

const items = ref(6);
const isShowMoreVs = ref(0);
const isShowMoreHome = ref(0);
const isShowMoreAway = ref(0);

const handleShowMore = (_mode: string) => {
  if (_mode === "vs") {
    isShowMoreVs.value = 2;
  } else if (_mode === "home") {
    isShowMoreHome.value = 2;
  } else if (_mode === "away") {
    isShowMoreAway.value = 2;
  }
};

const tournaments = computed(() => {
  if (instance?.proxy?.gSportType === "volleyball") {
    return props.h2h?.uniqueTournaments ?? [];
  }

  return props.h2h?.tournaments ?? [];
});

const h2hVs = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.vs)) {
    return [];
  }

  const data = props.h2h.vs.filter((item: any) => {
    let check = true;
    if (check && activeTab.value === "home") {
      check = props.match.home_team?.id === item.home_team_id;
    }

    if (check && activeTab.value === "away") {
      check = props.match.away_team?.id === item.away_team_id;
    }

    if (
      check &&
      filterGround.value !== null &&
      filterGround.value !== undefined
    ) {
      check = item.tournament.ground_id === filterGround.value;
    }

    if (check) {
      if (instance?.proxy?.gSportType === "volleyball") {
        if (filterIsThisSession.value) {
          check =
            props.match.unique_tournament_id === item.unique_tournament_id;
        }
      } else {
        if (filterIsSingles.value) {
          check =
            item.home_team.sub_ids.length === 0 &&
            item.away_team.sub_ids.length === 0;
        } else {
          check =
            item.home_team.sub_ids.length > 0 &&
            item.away_team.sub_ids.length > 0;
        }
      }
    }

    return check;
  });

  let _data = data.sort((a: any, b: any) => {
    return a.match_time > b.match_time ? -1 : 1;
  });

  if (isShowMoreVs.value != 2) {
    isShowMoreVs.value = _data.length > 6 ? 1 : 0;
  }

  if (isShowMoreVs.value == 2) {
    return _data;
  }

  return _data.slice(0, items.value);
});

const h2hHome = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.home)) {
    return [];
  }

  const data = props.h2h.home.filter((item: any) => {
    let check = true;

    if (check && activeTab.value === "home") {
      check =
        props.match.home_team_id === item.home_team_id ||
        props.match.home_team_id === item.away_team_id;
    }

    if (
      check &&
      filterGround.value !== null &&
      filterGround.value !== undefined
    ) {
      check = item.tournament.ground_id === filterGround.value;
    }
    if (check) {
      if (instance?.proxy?.gSportType === "volleyball") {
        if (filterIsHomeGround.value) {
          check = props.match.home_team_id === item.home_team_id;
        }

        if (filterIsThisSession.value) {
          check =
            props.match.unique_tournament_id === item.unique_tournament_id;
        }
      } else {
        if (filterIsSingles.value) {
          check = item.home_team.sub_ids.length === 0;
        } else {
          check = item.home_team.sub_ids.length > 0;
        }
      }
    }

    return check;
  });

  const _data = data.sort((a: any, b: any) => {
    return a.match_time > b.match_time ? -1 : 1;
  });
  _winHome.value = _getWinsLoses(_data, "win");
  _losesHome.value = _getWinsLoses(_data, "lose");

  if (isShowMoreHome.value != 2) {
    isShowMoreHome.value = _data.length > 6 ? 1 : 0;
  }

  if (isShowMoreHome.value == 2) {
    return _data;
  }

  return _data.slice(0, items.value);
});

const h2hAway = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.away)) {
    return [];
  }

  const data = props.h2h.away.filter((item: any) => {
    let check = true;
    if (check && activeTab.value === "away") {
      check =
        props.match.away_team_id === item.away_team_id ||
        props.match.away_team_id === item.home_team_id;
    }
    if (
      check &&
      filterGround.value !== null &&
      filterGround.value !== undefined
    ) {
      check = item.tournament.ground_id === filterGround.value;
    }
    if (check) {
      if (instance?.proxy?.gSportType === "volleyball") {
        if (filterIsHomeGround.value) {
          check = props.match.home_team_id === item.away_team_id;
        }

        if (filterIsThisSession.value) {
          check =
            props.match.unique_tournament_id === item.unique_tournament_id;
        }
      } else {
        if (filterIsSingles.value) {
          check = item.away_team.sub_ids.length === 0;
        } else {
          check = item.away_team.sub_ids.length > 0;
        }
      }
    }

    return check;
  });

  let _data = data.sort((a: any, b: any) => {
    return a.match_time > b.match_time ? -1 : 1;
  });

  _winAway.value = _getWinsLoses(_data, "win");
  _losesAway.value = _getWinsLoses(_data, "lose");

  if (isShowMoreAway.value != 2) {
    isShowMoreAway.value = _data.length > 6 ? 1 : 0;
  }

  if (isShowMoreAway.value == 2) {
    return _data;
  }

  return _data.slice(0, items.value);
});
</script>
